import React from 'react';

import { flagStyles } from '../settings';

const SvgLS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3120px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLS;
